import customerAPI from '@/services/API/customer'
import systemAPI from '@/services/API/system'
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
import { customerOverrides } from 'portaus-web-overrides';
import i18n from '../../../i18n';

/**
 * Validate s'il y a déja un default billing contact.
 * S'il existe un default billing contact on demande
 * si l'utilisateur veut vraiment ajouter ce contact
 * comme default billing contact au profit de l'autre.
 * @param  {[type]} companyContacts [Array de contacts]
 * @return {[type]}                 [Promise]
 */
function validateDefaultBillingContact(currentIndex,companyContacts){

  let findDefaultBillingContactIndex = _.findIndex(companyContacts, c=>{return c.default_billing_ind});
  if(findDefaultBillingContactIndex!=-1 && findDefaultBillingContactIndex!=currentIndex){
    return MessageBox.confirm(i18n.t('clients.billingContactWarning'),i18n.t('clients.billingContactWarningTitle'),{
      confirmButtonText: i18n.t('common.yes'),
      cancelButtonText: i18n.t('common.Cancel'),
      type: 'warning'
    }).then(()=>findDefaultBillingContactIndex)
  }else{
    return Promise.resolve(-1);
  }
}
/**
 * Validate s'il y a déja un default shipping contact.
 * S'il existe un default shipping contact on demande
 * si l'utilisateur veut vraiment ajouter ce contact
 * comme default shipping contact au profit de l'autre.
 * @param  {[type]} companyContacts [Array de contacts]
 * @return {[type]}                 [Promise]
 */
function validateDefaultShippingContact(currentIndex,companyContacts){

  let findDefaultShippingContactIndex = _.findIndex(companyContacts, c=>{return c.default_shipping_ind});
  if(findDefaultShippingContactIndex!=-1 && findDefaultShippingContactIndex!=currentIndex){
    return MessageBox.confirm(i18n.t('clients.shippingContactWarning'),i18n.t('clients.shippingContactWarningTitle'),{
      confirmButtonText: i18n.t('common.yes'),
      cancelButtonText: i18n.t('common.Cancel'),
      type: 'warning'
    }).then(()=>findDefaultShippingContactIndex)
  }else{
    return Promise.resolve(-1);
  }
}

const setCorporateCustomerProp = function({commit,dispatch}, corporateCustomer){
  _.forEach([,'id','name','usual_name', 'phone','email', 'phoneExt'],prop=>{
    if(corporateCustomer.hasOwnProperty(prop)){
      commit('SET_CORPORATE_CUSTOMER_PROPERTY', {propName : prop, propVal:corporateCustomer[prop]});
    }
  })
}

const setIndividualCustomerProp = function({commit,dispatch}, individualCustomer){
  _.forEach(['id','first_name','last_name', 'phone','email', 'phoneExt', 'sex','denomination'],prop=>{
    if(individualCustomer.hasOwnProperty(prop)){
      commit('SET_INDIVIDUAL_CUSTOMER_PROPERTY', {propName : prop, propVal:individualCustomer[prop]});
    }
  })
}

const setCustomerSettingProperty = function({state,commit,dispatch}, settingsProp){
  // console.log('SET Customer Setting Property : ', settingsProp);
  _.forEach(['customerClass','tags','currency','language','paymentMethods','term','lateFeeActivated','indTypeFee','fee','gracePeriod','deliveryType','location','reminderActivated','nbDaysReminder','lateFeeReminderActivated','customerDeliverySchedules','invoice_before_processing','taxes','taxable', 'online_invoicing_ind','invoiceReminders', 'reservationNotificationInd', 'reservationNotificationType','reservationNotificationEmailCustomContent'],prop=>{
    if(settingsProp.hasOwnProperty(prop)){

      let indNew = settingsProp.new==null?true:settingsProp.new;

      return customerOverrides.before_set_customer_settings(state.settings, {propName : prop, propVal:settingsProp[prop]}, indNew)
      .then(customerSeetingsToSet=>{
          _.forEach(customerSeetingsToSet, s=>{
              commit('SET_CUSTOMER_SETTINGS_PROPERTY', s);
          })
      })

    }
  })
}

const setType = function({commit}, type){
  commit('SET_TYPE',type);
}

const setParent = function({commit}, parent) {
  commit('SET_PARENT', parent === '' ? null : parent);
}

const setExternalId = function({commit}, externalId) {
  commit('SET_EXTERNAL_ID', externalId);
}

const setUsualNameIfNotSet = function({commit, state}){
  if(state.company.usual_name==null || state.company.usual_name===''){
    commit('SET_CORPORATE_CUSTOMER_PROPERTY',{propName : 'usual_name', propVal:state.company.name})
  }
}

const resetCustomerInfo = function ({commit}){
  commit('RESET_CUSTOMER_INFO');
}

const disableCtrl = function ({commit}){
  commit('SET_DISABLED_CTRL', true);
}

const enableCtrl = function ({commit}){
  commit('SET_DISABLED_CTRL', false);
}

const addAddress = function ({commit, dispatch}, address){
  dispatch('enableCtrl');
  commit('ADD_ADDRESS',address);
}

const updateAddress = function ({commit, dispatch}, {index, address}){
  dispatch('enableCtrl');
  commit('UPDATE_ADDRESS',{index, address});
}

const removeAddress = function ({commit, dispatch}, index){
  MessageBox.confirm(i18n.t('clients.removeAddressWarning'), i18n.t('clients.removeAddressWarningTitle'), {
    confirmButtonText: i18n.t('common.yes'),
    cancelButtonText: i18n.t('common.Cancel'),
    type: 'warning',
    center: true
  }).then(()=>{
    commit('REMOVE_ADDRESS', index);
  }).catch(()=>{/*do nothing**/})
}

const addCompanyContact = function({commit, state}, contact){
  const duplicateContact = _.find(state.company.contacts, c=>{
    return c.id==contact.id;
  })
  if(duplicateContact!=null){
    Message.error(i18n.t('clients.contactAlreadyAssociated'));
  }else{
    let contactCloned = _.cloneDeep(contact);
    let c = {};
    c.first_name = contactCloned.first_name;
    c.last_name = contactCloned.last_name;
    c.id = contactCloned.id;
    c.email = contactCloned.email;
    c.phone = contactCloned.phone;
    c.work_email = contactCloned.email;
    c.work_phone = contactCloned.phone;
    c.work_phone_ext = contactCloned.ext;
    c.role = null;
    c.primary = false;
    c.send_invoice_notice = false;
    c.send_reservation_orders_ind = false;
    c.default_billing_ind = false;
    c.default_shipping_ind = false;
    commit('ADD_COMPANY_CONTACT', c);
  }
}

const removeCompanyContact = function({commit, state}, index){
  commit('REMOVE_COMPANY_CONTACT', index);
}

const updateCompanyContactProperty = function({commit, state}, {index, contactProps}){
  _.forEach(['role','work_phone','work_phone_ext', 'work_email','primary','send_invoice_notice', 'send_reservation_orders_ind', 'default_billing_ind','default_shipping_ind'],prop=>{
    if(contactProps.hasOwnProperty(prop)){
      if(prop==="default_billing_ind"){
        validateDefaultBillingContact(index,state.company.contacts)
          .then(defaultBillingContactIndex=>{
            if(defaultBillingContactIndex!=-1)commit('UPDATE_COMPANY_CONTACT_PROPERTY', {index:defaultBillingContactIndex, propName : prop, propVal:false});
            commit('UPDATE_COMPANY_CONTACT_PROPERTY', {index, propName : prop, propVal:contactProps[prop]});
          })
          .catch(()=>{})
      }else if(prop==="default_shipping_ind"){
        validateDefaultShippingContact(index,state.company.contacts)
          .then(defaultShippingContactIndex=>{
            if(defaultShippingContactIndex!=-1)commit('UPDATE_COMPANY_CONTACT_PROPERTY', {index:defaultShippingContactIndex, propName : prop, propVal:false});
            commit('UPDATE_COMPANY_CONTACT_PROPERTY', {index, propName : prop, propVal:contactProps[prop]});
          })
          .catch(()=>{})
      }else{
        commit('UPDATE_COMPANY_CONTACT_PROPERTY', {index, propName : prop, propVal:contactProps[prop]});
      }

    }
  })
}

const resetAddresses = function({commit}){
  commit('SET_ADDRESSES', []);
}

const resetContacts = function({commit}){
  commit('SET_COMPANY_CONTACT',[])
}

const resetConfiguration = function({commit}){
  commit('RESET_CONFIGURATION');
}

const resetAll = function({commit,dispatch}){
  dispatch('resetCustomerInfo');
  dispatch('resetAddresses');
  dispatch('resetContacts');
  dispatch('resetConfiguration');
}

const fetchDefaultCustomerSettings = function({state, dispatch}){
  return systemAPI.fetchDefaultCustomerSettings()
    .then(defaultCustomerSettings=>{
      // Initialisation de la configuration par défaut
      // console.log("defaultCustomerSettings : ", defaultCustomerSettings);
      dispatch('setCustomerSettingProperty',{paymentMethods:defaultCustomerSettings.PAYMENT_OPTIONS, new:false});
      dispatch('setCustomerSettingProperty',{currency:defaultCustomerSettings.INVOICING_OPTIONS.currency_id, new:false});
      const term = _.find(state.terms, t=>{
        return t.id==defaultCustomerSettings.INVOICING_OPTIONS.term;
      })
      dispatch('setCustomerSettingProperty',{term, new:false});
      dispatch('setCustomerSettingProperty',{lateFeeActivated:defaultCustomerSettings.INVOICING_OPTIONS.late_fee_activated, new:false});
      dispatch('setCustomerSettingProperty',{indTypeFee:defaultCustomerSettings.INVOICING_OPTIONS.ind_type_fee, new:false});
      dispatch('setCustomerSettingProperty',{fee:defaultCustomerSettings.INVOICING_OPTIONS.fee, new:false});
      dispatch('setCustomerSettingProperty',{gracePeriod:defaultCustomerSettings.INVOICING_OPTIONS.grace_period, new:false});
      dispatch('setCustomerSettingProperty',{language:defaultCustomerSettings.LANGUAGE.language_id, new:false});
      dispatch('setCustomerSettingProperty',{reminderActivated:defaultCustomerSettings.NOTIFICATIONS.invoice_reminder.active, new:false});
      dispatch('setCustomerSettingProperty',{invoiceReminders: defaultCustomerSettings.NOTIFICATIONS.invoice_reminder.configuration || [], new: false});
      dispatch('setCustomerSettingProperty',{nbDaysReminder:defaultCustomerSettings.NOTIFICATIONS.invoice_reminder.nd_days, new:false});

      dispatch('setCustomerSettingProperty',{reservationNotificationInd: _.get(defaultCustomerSettings, 'NOTIFICATIONS.reservation_reminder.active'), new:false});
      dispatch('setCustomerSettingProperty',{reservationNotificationType: _.get(defaultCustomerSettings, 'NOTIFICATIONS.reservation_reminder.type') || null, new: false});
      let reservationEcc = _.get(defaultCustomerSettings, 'NOTIFICATIONS.reservation_reminder.email_custom_content_id') != null ? {id: _.get(defaultCustomerSettings, 'NOTIFICATIONS.reservation_reminder.email_custom_content_id')} : null;
      dispatch('setCustomerSettingProperty',{reservationNotificationEmailCustomContent: reservationEcc, new:null});
      
      
    })
}

const saveCustomer = function({state, dispatch}, action){

  let postValue = {};
  postValue.contacts = [];

  //Pour un client corporatif
  if(state.type==="1"){

    //gestion des contacts
    _.forEach(state.company.contacts, c=>{
      let contact = {};
      //Activation des contact sur la compagnie
      contact.active = true;
      contact.id=c.id;
      contact.role = c.role;
      contact.work_email = c.work_email;
      contact.work_phone = c.work_phone;
      contact.work_phone_ext = c.work_phone_ext;
      contact.ind_primary = c.primary;
      contact.send_invoice_notice = c.send_invoice_notice;
      contact.send_reservation_orders_ind = c.send_reservation_orders_ind;
      contact.default_shipping_ind = c.default_shipping_ind;
      contact.default_billing_ind = c.default_billing_ind
      postValue.contacts.push(contact);
    })

    //informatin de la compagnie
    postValue.company = state.company;
    //Adresses de la compagnie
    postValue.company.addresses = state.addresses;
  }else{
      //Client individuel
      let contact = {};
      contact.id = state.contact.id;
      contact.first_name = state.contact.first_name;
      contact.last_name =state.contact.last_name;
      contact.email = state.contact.email;
      contact.sex = state.contact.sex;
      contact.denomination = state.contact.denomination;
      contact.phone = state.contact.phone;
      contact.phone_ext = state.contact.phoneExt;
      contact.addresses = state.addresses;
      postValue.contacts.push(contact);
  }

  //Éléments communs
  postValue.type = state.type;
  postValue.externalId = state.externalId;
  postValue.settings = state.settings;
  postValue.territory_id = state.territory!=null?state.territory.id:null;
  postValue.rep_id = state.rep_id;
  if (state.parent != null) {
    postValue.parent = {
      id: state.parent.id,
    }
  } else {
    postValue.parent = null;
  }

  postValue.notifications = [];

  _.forEach(state.settings.invoiceReminders, (r, i)=>{
    let notification = _.cloneDeep(r);
    notification.customer_id=state.customerId;
    notification.order=i+1;
    postValue.notifications.push(notification);
  })

  if(state.settings.reservationNotificationInd === true) {
    let notification = _.cloneDeep(state.reservationReminder);
    notification.customer_id=state.customerId;
    notification.configuration = { type: state.settings.reservationNotificationType };
    notification.order=0;

    notification.email_custom_content_id = state.settings.reservationNotificationEmailCustomContent.id
    postValue.notifications.push(notification);

  }


  // console.log("POSTVALUE : ", postValue);
  if(action==="CREATE"){
    return customerOverrides.before_save_customer(postValue)
      .then(postValue=>{
        return customerAPI.createCustomer(postValue)
          .then(customer=>{
              dispatch('customers/invalidateList',null,{root:true});
              Message.success(i18n.t('clients.clientCreatedSuccess'))
              return customer;

          })
      })

  }else{
    return customerAPI.updateCustomer(postValue, state.customerId)
      .then(customer=>{
          dispatch('customers/invalidateList',null,{root:true});
          Message.success(i18n.t('clients.clientEditedSuccess'))
          return customer;
      })
  }

}


const cloneCustomerForEdition = function({commit, state, dispatch}, customer){
  let clonedCustomer = _.cloneDeep(customer);
  // console.log("customer : ", customer);

  commit('SET_CUSTOMER_ID', customer.id);

  dispatch('setType',clonedCustomer.type.toString());
  dispatch('setExternalId',clonedCustomer.externalId);
  dispatch('setParent',clonedCustomer.parent);
  dispatch('setTerritory',clonedCustomer.territory);
  dispatch('setRep',clonedCustomer.rep_id);

  if(clonedCustomer.type==1){
    //Corporate customer
    let corporateCustomer = {};
    corporateCustomer = {};
    corporateCustomer.id = clonedCustomer.company.id;
    corporateCustomer.name = clonedCustomer.company.name;
    corporateCustomer.usual_name = clonedCustomer.company.usual_name;
    corporateCustomer.email = clonedCustomer.company.email;
    if(clonedCustomer.company.phone!=null){
      corporateCustomer.phone=clonedCustomer.company.phone;
    }
    corporateCustomer.phoneExt = clonedCustomer.company.phoneExt;

    dispatch('setCorporateCustomerProp',corporateCustomer )
    commit('SET_ADDRESSES', clonedCustomer.company.addresses);

    let companyContacts = [];
    _.forEach(clonedCustomer.company.contacts, c=>{
      if(c.active){
        let contact = {};
        contact.id = c.id;
        contact.first_name = c.first_name;
        contact.last_name = c.last_name;
        contact.role = c.role;
        contact.work_email = c.work_email;
        contact.work_phone = c.work_phone;
        contact.work_phone_ext = c.work_phone_ext;
        contact.primary = c.ind_primary;
        contact.sex = c.sex;
        contact.denomination = c.denomination;
        contact.send_invoice_notice = c.send_invoice_notice;
        contact.send_reservation_orders_ind = c.send_reservation_orders_ind;
        contact.default_billing_ind = c.default_billing_ind;
        contact.default_shipping_ind = c.default_shipping_ind;
        companyContacts.push(contact);
      }
    })
    commit('SET_COMPANY_CONTACT',companyContacts);
  }else{
    //Individual Customer
    let individualCustomer ={};
    individualCustomer.id = clonedCustomer.contact.id;
    individualCustomer.first_name = clonedCustomer.contact.first_name;
    individualCustomer.last_name = clonedCustomer.contact.last_name;
    individualCustomer.sex = clonedCustomer.contact.sex;
    individualCustomer.denomination = clonedCustomer.contact.denomination;
    individualCustomer.email = clonedCustomer.contact.email;
    if(clonedCustomer.contact.phone!=null){
      individualCustomer.phone = clonedCustomer.contact.phone;
    }
    individualCustomer.phoneExt = clonedCustomer.contact.phone_ext;

    dispatch('setIndividualCustomerProp',individualCustomer )
    commit('SET_ADDRESSES', clonedCustomer.contact.addresses);
  }
  //Éléments communs


  //customer settings
  let settings = {};
  if(clonedCustomer.taxes!=null){
    settings.taxes = clonedCustomer.taxes;
  }

  if (clonedCustomer.taxable!=null){
    settings.taxable = clonedCustomer.taxable;
  }
  if(clonedCustomer.customer_class!=null){
    settings.customerClass = clonedCustomer.customer_class;
  }
  if(clonedCustomer.tags!=null){
    settings.tags = clonedCustomer.tags;
  }
  if(clonedCustomer.currency!=null){
    settings.currency = clonedCustomer.currency.id;
  }
  if(clonedCustomer.language!=null){
    settings.language = clonedCustomer.language.id;
  }
  if(clonedCustomer.paymentOptions!=null){
    let paymentMethods = [];
    _.forEach(clonedCustomer.paymentOptions, p=>{
      paymentMethods.push(p.id);
    })
    settings.paymentMethods = paymentMethods;
  }
  if(clonedCustomer.invoice_term!=null){
    settings.term = clonedCustomer.invoice_term;
  }
  settings.invoice_before_processing = clonedCustomer.invoice_before_processing;
  settings.online_invoicing_ind = clonedCustomer.online_invoicing_ind;
  settings.customerDeliverySchedules = clonedCustomer.customer_delivery_schedules;
  settings.lateFeeActivated = clonedCustomer.late_fee_activated;
  settings.indTypeFee = clonedCustomer.ind_type_fee;
  settings.fee = clonedCustomer.fee;
  settings.gracePeriod = clonedCustomer.grace_period;
  if(clonedCustomer.delivery_type!=null){
    settings.deliveryType = clonedCustomer.delivery_type;
    if(settings.deliveryType.choice_custom_info!=null && clonedCustomer.extra_info!=null && clonedCustomer.extra_info.location!=null){
      settings.location=clonedCustomer.extra_info.location;
    }
  }
  settings.reminderActivated = clonedCustomer.reminder_activated;
  settings.nbDaysReminder = clonedCustomer.nb_days_reminder;
  settings.reminderType = clonedCustomer.reminder_type;

  settings.lateFeeReminderActivated = clonedCustomer.late_fee_notification_activated;
  settings.new = false;
  settings.invoiceReminders =[];

  settings.reservationNotificationInd = clonedCustomer.reservation_notification_ind;
  settings.reservationNotificationType = clonedCustomer.reservation_notification_type;

  _.forEach(clonedCustomer.notifications, n=>{
    if(n.type=="INVOICE_REMINDER"){
      settings.invoiceReminders.push(n);
    }
    if(n.type=="RESERVATION_REMINDER"){
      settings.reservationNotificationEmailCustomContent = { id: n.email_custom_content_id };
    }
  })




  dispatch('setCustomerSettingProperty',settings );

}

const setSchedule = function({state, dispatch}, {mode, schedule}){
  // console.log("set new schedule: ", {mode, schedule});
  let newSchedule = [];
  if(mode==="FIXEDDAYS"){
    _.forEach(schedule, d=>{
      let clonedD = _.cloneDeep(d);
      if(clonedD.customer_id==null && state.customerId!=null){
        clonedD.customer_id=state.customerId;
      }
      newSchedule.push(clonedD);
    })
  }
  dispatch('setCustomerSettingProperty',{customerDeliverySchedules:newSchedule});

}

const setTerritory = function({state, commit}, territory){
  commit('SET_TERRITORY', territory);
}

const setRep = function({state, commit}, rep_id){
  commit('SET_REP', rep_id);
}

const addInvoiceReminder = function ({state, commit}, invoiceReminder){
  commit('ADD_INVOICE_REMINDER', invoiceReminder);
}
const removeInvoiceReminder = function ({state, commit}, index){
  commit('REMOVE_INVOICE_REMINDER', index);
}

const setInvoiceReminderConfigurationProperty = function({state, commit}, {index, itemProp}){
  _.forEach(['type', 'nbDays'],prop=>{
    if(itemProp.hasOwnProperty(prop)){
      commit('SET_INVOICE_REMINDER_CONFIGURATION_PROPERTY', {propName : prop, propVal:itemProp[prop],index});

    }
  })
}

const setInvoiceReminderProperty = function({state, commit}, {index, itemProp}){
  _.forEach(['email_custom_content_id'],prop=>{
    if(itemProp.hasOwnProperty(prop)){
      commit('SET_INVOICE_REMINDER_PROPERTY', {propName : prop, propVal:itemProp[prop],index});

    }
  })
}




export default {
  setCorporateCustomerProp,
  setIndividualCustomerProp,
  setType,
  setUsualNameIfNotSet,
  resetCustomerInfo,
  disableCtrl,
  enableCtrl,
  addAddress,
  updateAddress,
  removeAddress,
  addCompanyContact,
  removeCompanyContact,
  updateCompanyContactProperty,
  setCustomerSettingProperty,
  fetchDefaultCustomerSettings,
  resetAll,
  resetAddresses,
  resetContacts,
  resetConfiguration,
  saveCustomer,
  cloneCustomerForEdition,
  setSchedule,
  setTerritory,
  setRep,
  addInvoiceReminder,
  removeInvoiceReminder,
  setInvoiceReminderConfigurationProperty,
  setInvoiceReminderProperty,
  setParent,
  setExternalId
};
